<template>
  <header>
    <div class="app-header-branding">
      <a href="http://www.dmv.ri.gov/" title="Go to RI DMV Home Page">
         <img src="@ridmv/web-themes/images/logo.png" alt="RI DMV logo">
      </a>
      <div class="app-header-dmv">
        <div>State of Rhode Island</div>
        <div>Division of Motor Vehicles</div>
        <div>Department of Revenue</div>
      </div>
    </div>

    <div class="app-header-info">
      <div>
        <a href="http://www.dmv.ri.gov/contact/" target="_blank" rel="noopener noreferrer">Contact us</a>
        <a href="http://www.dmv.ri.gov/" target="_blank" rel="noopener noreferrer">RI DMV Home Page</a>
      </div>
    </div>
  </header>
</template>

<script setup>
defineOptions({
  name: 'AppHeader',
});
</script>


<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/header";
</style>
